export default {
	navigation: {
		individual: {
			label: '개인',
			menu_items: {
				online_shopping: '온라인 쇼핑',
				offline_kiosk: '오프라인 키오스크',
				pay_with_qr: 'QR코드 결제',
				jpworldpay_creditcard: 'JP WORLD PAY 신용카드',
				transaction_cashback: '거래 및 캐시백',
				send_asset: '자산 보내기',
				asset_request: '자산 요청',
				get_deposit: '입금 받기',
				fee: '수수료',
				wallet: '지갑',
				account: '계정',
				jpys: 'JPYS 추가',
				sell: '판매',
				exchanging_currency: '환전',
			},
		},
		business: {
			label: '비즈니스',
		},
		development: {
			label: '개발',
		},
		customer_service: {
			label: '고객 서비스',
		},
	},
	auth: {
		login: '로그인',
		signup: '회원가입',
	},
	accessibility: {
		toggle_navigation: '내비게이션 토글',
		logo_alt: '로고',
		language_selector: {
			alt: '언어 선택',
			current_language: '한국어',
		},
	},
};
